import React from 'react';
import * as enums from '@local/finsera-core/src/enums';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import RelaxOrder from './relax-order';
import NumericField from '../../numeric-field';

type MaximumRiskProps = {
  params: types.optimizer.MaximumRiskDraft;
  setParams: (_params: types.optimizer.MaximumRiskDraft) => void;
  readOnly: boolean;
  validationDef: types.common.ValidationErrors;
  optimizerType: 'basket' | 'backtest';
};

const MaximumRisk = ({ params, setParams, readOnly, validationDef, optimizerType }: MaximumRiskProps) => {
  React.useEffect(() => {
    if (optimizerType == 'basket' && params.benchmark_relative == null) {
      setParams({ benchmark_relative: true });
    }
  }, []);

  return (
    <mui.core.Box p={2}>
      <mui.core.Grid container spacing={4}>
        <mui.core.Grid item xs={12} md={4}>
          <NumericField
            textFieldProps={{
              label: 'Maximum Annualized Risk',
              fullWidth: true,
              variant: 'outlined',
              size: 'small',
              required: true,
              error: validationDef?.fields?.includes('maximum_annualized_risk'),
            }}
            disabled={readOnly}
            value={params.upper_bound}
            setValue={(v) => setParams({ ...params, upper_bound: v })}
            suffix="%"
            dividerOption={enums.NUMBER_FORMATTERS_ENUM.HUNDRED}
          />
        </mui.core.Grid>

        <mui.core.Grid item xs={12} md={4}>
          <RelaxOrder params={params} setParams={setParams} disabled={readOnly} />
        </mui.core.Grid>

        <mui.core.Grid item xs={12} md={4}>
          <mui.core.Box px={3}>
            <mui.core.FormControlLabel
              control={
                <mui.core.Switch
                  size="small"
                  checked={params.benchmark_relative}
                  onChange={() =>
                    setParams({
                      ...params,
                      benchmark_relative: !params.benchmark_relative,
                    })
                  }
                  disabled={readOnly}
                />
              }
              label={optimizerType == 'backtest' ? 'Benchmark Relative' : 'Relative to Target Weights'}
            />
          </mui.core.Box>
        </mui.core.Grid>
      </mui.core.Grid>
    </mui.core.Box>
  );
};

export default MaximumRisk;
